import { Component,Input } from '@angular/core';

@Component({
    selector: 'icon-arrow-left',
    templateUrl: './arrow-left.component.html',
    styleUrls: ['./arrow-left.component.css'],
    standalone: false
})
export class ArrowLeftComponent {
  @Input() size=24;
  @Input() color='#000';
}
